module.exports = __webpack_public_path__ + "static/media/Cervell.f447bd8a.svg";